var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{ref:"translateWidget",staticClass:"translateWidget",attrs:{"id":"translateWidget"}})}
var staticRenderFns = []

export { render, staticRenderFns }